import React from 'react';
import styled from 'styled-components';
import { lightGrey1Color, lightGrey2Color, clearFix } from 'js/config/style';
import { Link } from '@reach/router';

export default styled(({ to, children, ...rest }) => (
  <div {...rest}>
    <Link to={to}>{children}</Link>
  </div>
))`
  a {
    position: relative;
    display: block;
    padding: 1rem 3rem 1rem 1rem;
    overflow: hidden;
    ${clearFix}
    cursor: pointer;

    &:hover {
      color: ${lightGrey2Color.darken()};
      background: ${lightGrey1Color};
      text-decoration: none;
    }

    &:active {
      background: ${lightGrey1Color.darken(0.1)};
    }

    && + && {
      border-top: 1px solid ${lightGrey1Color};
    }
  }
`;
